import "../../css/UserPageStyle/profile.css"


function ProfileBodyBottom(props) {
    
    return (
        <div className="profile-body-bottom">
            {props.children}
        </div>
    );
}

export default ProfileBodyBottom;


